module.exports = __webpack_public_path__ + "assets/3167937d15d25810a9c6f39c22793ac8.png";